/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface OperatorActivationDetailsCommon { 
    activation_request_list?: Array<object>;
    activation_response_list?: Array<object>;
    activation_status_request_list?: Array<object>;
    activation_status_response_list?: Array<object>;
    api_error_list?: Array<object>;
    deactivation_accepted_by?: string;
    deactivation_accepted_task_id?: string;
    deactivation_accepted_timestamp?: Date;
    deactivation_request_list?: Array<object>;
    deactivation_response_list?: Array<object>;
    deactivation_status_request_list?: Array<object>;
    deactivation_status_response_list?: Array<object>;
    msp_org_groups_details?: Array<object>;
}

